// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----Navigation-module---container---1vuqK","bg":"src-components----Navigation-module---bg---2hK8z","logo":"src-components----Navigation-module---logo---29lHq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation.module.css
// module id = 128
// module chunks = 35783957827783 43201937662106